import React, { useState } from 'react';

import './CoursePaymentOffer.scss';
import { getString } from '../../helpers/styles';
import icons from '../../shared/assets/icons/redesign';

const { IdealPayment } = icons;

export default function CoursePaymentOffer({ paymentLink }) {
  const [checked, setChecked] = useState(false);

  return (
    <div className="coursePaymentOffer">
      <h2 className="coursePaymentOffer-title">
        356 dagen onbeperkt toegangg tot de cursussen omgeving
      </h2>

      <ul className="coursePaymentOffer-list">
        <li className="coursePaymentOffer-list-item">
          <div className="coursePaymentOffer-list-item-number">1</div>
          <p className="coursePaymentOffer-list-item-text">
            Betaal nu het volledige bedrag van €99,99 i.p.v €350
          </p>
        </li>

        <li className="coursePaymentOffer-list-item">
          <div className="coursePaymentOffer-list-item-number">2</div>
          <p className="coursePaymentOffer-list-item-text">
            Declareer het bedrag bij jouw zorgverzekering.
          </p>
        </li>

        <li className="coursePaymentOffer-list-item">
          <div className="coursePaymentOffer-list-item-number">3</div>
          <p className="coursePaymentOffer-list-item-text">
            Het bedrag wordt teruggestort afhankelijk je zorgverzekering
          </p>
        </li>
      </ul>

      <div
        className={getString([{
          value: 'coursePaymentOffer-checkbox',
          condition: true
        }, {
          value: 'coursePaymentOffer-checkbox-checked',
          condition: checked
        }])}
        onClick={() => {
          setChecked(!checked)
        }}
      >
        <div>
          <IdealPayment className="coursePaymentOffer-checkbox-image" />
          Ideal
        </div>

        <span className="coursePaymentOffer-checkmark">
          <span className="coursePaymentOffer-checkmark-content">
            &#10003;
          </span>
        </span>
      </div>

      <a
        className={getString([{
          value: 'coursePaymentOffer-button',
          condition: true
        }, {
          value: 'coursePaymentOffer-button-active',
          condition: checked
        }])}
        href={paymentLink}>
        Afrekenen
      </a>
    </div>
  );
}
